<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
export interface PagesOfficesDetailNoteProps {
    note: string
}

const props = defineProps<PagesOfficesDetailNoteProps>()
</script>
<template>
  <PagesOfficesDetailBox>
    <h2 class="delta mb-3">
      {{ $t('Poznámka') }}
    </h2>
    <Typo>
      <div
        class="fs-bigger"
        v-html="props.note"
      />
    </Typo>
  </PagesOfficesDetailBox>
</template>
